import { LAYOUT } from '../../../../styles/themes/constants';
import { media } from '../../../../styles/themes/constants';
import styled, { css } from 'styled-components';

interface Header {
  $isTwoColumnsLayoutHeader: boolean;
}

export const Header = styled.div<Header>`
  line-height: 1.5;
  background: transparent;
  border: none;
  padding: 0;
  height: auto;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 10; /* Поднимаем выше фона */

  > div {
    width: 100%;
  }
`;
